// createManager.js
import axiosInstance from 'services/axiosMiddleware';

export async function sendCredential(userdata) {
  try {
    const response = await axiosInstance.post('users/send-credentials', userdata);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}